<template>
    <div>
        <top></top>
        <navMenu></navMenu>
        <div class="inner  clearfix">
            <div class="questionstitle clearfix">
                <div @click="getback"><i class="el-icon-back"></i>返回试题库</div>
                <div class="questiontitleright ">
                    <el-row :gutter="15">
                        <el-col :span="8" >&nbsp;<div v-show="this.checksave != ''">已选 <span style="color:#3b8bfd;">{{this.checksave.length}}</span>题</div></el-col>
                        <el-col :span="8" style="color:#3b8bfd;cursor:pointer;" @click.native="questioncheck">查看<div></div></el-col>
                        <el-col :span="8"><el-button type="primary" @click="postwork">保存</el-button></el-col>
                    </el-row>
                </div>
            </div>
            <div class="indexworkleft fl">
                <taskleft></taskleft>
            </div>
            <div class="indexworkright fr">
                <wklistr></wklistr> 
            </div>
        </div>



        <!-- 选择试题列表 -->
        <div class="checkquestionlistpopup" v-show="this.checkpopup == true">
            <div>
                <div class="questionstitle clearfix">
                    <div @click="offpopup"><i class="el-icon-back"></i>返回试题库</div>
                    <div class="checkcontent">已添加{{this.checksave.length}}题到作业</div>
                    <div class="checkright ">
                        <el-button type="primary" @click="postwork">保存</el-button>
                    </div>
                </div>
                <div class="questionlist">
                    <div class="questionlistdata clearfix" id="questionlistdata" v-for="(item,index) in this.checksave" :key="index" >
                        <div>
                            <span>{{index+1}}、</span>
                            <div><span>{{item.typename}}</span><span>难度: {{item.levelname}}</span><span>添加时间: {{item.addtime}}</span></div>
                            <div class="questionhtml clearfix" v-show="item.texttype == 2" v-html="item.text"></div>
                            <div class="questionhtml clearfix" v-show="item.texttype == 1" v-html="item.quetext"></div>
                        </div>
                        <div>
                            <div class="clearwork" @click="delquestion(item)"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="作业题目" :visible.sync="dialogFormVisible" width="400px" :close-on-click-modal="false">
            <el-input v-model="workname" autocomplete="off" placeholder="请填写作业题目"></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="uploaquestion">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>
<script>
import "../../assets/work.css"
import Taskleft from '../../components/work/taskleft.vue'
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
import wklistr from "@/components/work/worklistright.vue"
import URL from "../../api/index";
import eventBus from "@/api/eventBus";
export default {
    
    data(){
        return{
            questiondata:[],
            datalength:'',
            checkpopup: false,
            checksave:[],
            arr1:[],
            workname:'',
            dialogFormVisible:false
        }
    },
    components: {
        Taskleft,top,navMenu,wklistr
        
    },
    created(){
        eventBus.$on('dataleng', ( val ) => {
            console.log(val)
            this.datalength = val
            let checkdata
            console.log(localStorage.getItem("saveexaminfo"))
            // if( JSON.parse(localStorage.getItem("saveexaminfo")) == null ){
            //     checkdata = ""
            // }else{
            //     checkdata = JSON.parse(localStorage.getItem("saveexaminfo"))
            //     this.unique(checkdata) //初始化去重
            //     this.render(checkdata)
            //     this.checksave = checkdata
            //     console.log(this.checksave)
            // }
            checkdata = JSON.parse(localStorage.getItem("saveexaminfo"))
            this.unique(checkdata) //初始化去重
            this.render(checkdata)
            this.checksave = checkdata
            console.log(this.checksave)
            
            
        })
    },
    mounted(){
        let checkdata
        if( JSON.parse(localStorage.getItem("saveexaminfo")) == null ){
            checkdata = 0
        }else{
            checkdata = JSON.parse(localStorage.getItem("saveexaminfo"))
            this.unique(checkdata) //初始化去重
            this.render(checkdata)
            // this.checksave = checkdata
        }   
        this.examinfo = JSON.parse(localStorage.getItem("examinfo"))

        //试题兼容
        setTimeout(() => {
            this.$nextTick(function () {
                if(this.commonsVariable.isMathjaxConfig){
                    this.commonsVariable.initMathjaxConfig();
                }
                window.MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.getElementById('questionlistdata')]);
            })
        },500)
    },
    methods:{
        //保存
        postwork(){
            // this.dialogFormVisible = true
            console.log(this.checksave.length)
            if( this.checksave.length == 0 ){
                this.checkpopup = false
                
            }else{
                this.checkpopup = false
                eventBus.$emit("workname",this.workname) 
            }
            
        },
        //确定保存
        uploaquestion(){
            this.dialogFormVisible = false
            this.checkpopup = false
            eventBus.$emit("workname",this.workname)  
        },
        //渲染
        render(rows){
            rows.forEach( (res,index) => {
                var textfront = res.text.substring(0,4)
                if( textfront == 'http' ){
                    res.texttype = 1    
                    this.$get( res.text ).then( val =>{
                        let urltext = res.text.substring(0,59)//地址获取
                        let reg = new RegExp( 'src="' , "g" )//获取src
                        let answerquest = val.replace( reg, 'src="' +urltext);//src拼接
                        res.quetext = answerquest
                    })  
                }else{ 
                    res.texttype = 2
                    this.checksave = rows
                }
            })
            setTimeout(() => {
                this.checksave = rows
            }, 500);
        },

        //删除试题
        delquestion(item){
            //删除已选试题
            this.checksave.forEach( (res,index) => {
                if( res.questionid == item.questionid ){
                    this.checksave.splice(index,1);
                }
                localStorage.setItem("saveexaminfo",JSON.stringify(this.checksave))
            });
            //删除发布的
            this.examinfo.forEach( (val,index) => {
                val.questions.forEach( (res,inx) =>{
                    // console.log(res)
                    if( res == item.questionid ){
                        // console.log("一样",inx)
                        // console.log(this.examinfo[index]['questions'][inx])
                        this.examinfo[index]['questions'].splice(inx,1);
                        this.examinfo[index]['scores'].splice(inx,1);
                        localStorage.setItem("examinfo",JSON.stringify(this.examinfo))
                    }
                })
            });
  

        },
        //查看选择试题
        questioncheck(){
            this.checkpopup = true
        },
        unique(arr) {
            for (var i = 0, len = arr.length; i < len; i++) {
                for (var j = i + 1, len = arr.length; j < len; j++) {
                    if (arr[i].questionid === arr[j].questionid) {
                        arr.splice(j, 1);
                        j--;
                        len--;   
                    }
                }
            }
        },
        //返回试题库
        offpopup(){
            this.checkpopup = false
        },
        //返回  
        getback(){
            this.$router.go(-1)
        },
       
    }
}
</script>
<style scoped>
    .indexworkleft{
        background: none;
        padding: 0 10px 0 0;
    }

    body, html, div, blockquote, img, label, p, h1, h2, h3, h4, h5, h6, pre, ul, ol,
    li, dl, dt, dd, form, a, fieldset, input, th, td, i, em{
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -ms-box-sizing: border-box;
        box-sizing: border-box;
    }
    .indexworkright{
        background: none;
        padding: 0;
    }
    

</style>